import { app } from '../../../app';
import { Controller } from './slack-info.controller';

app.component('companySlackInfo', {
    bindings: {
        appType$: '<',
        code: '<',
        companyId: '<',
        state: '<',
    },
    controller: Controller,
    templateUrl: require('./slack-info.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/slack-info/slack-info.component.js